'use client';

import { Switch } from 'lighthouse';

import { isAttributeValueSelected } from '@/utilities/attributeFilters';

import { AttributeBooleanFilterProps } from '../../models';
import { AttributeFilterTitle } from '../AttributeFilterTitle';

export const AttributeBooleanFilter = ({ attribute, selection, draft, onSetValues }: AttributeBooleanFilterProps) => {
    const trueOption = attribute.options.find((option) => option.value === true || option.value === 'true');
    const falseOption = attribute.options.find((option) => option.value === false || option.value === 'false');
    const preferredOption = trueOption ?? falseOption;

    if (!preferredOption) {
        return null;
    }

    const isChecked = isAttributeValueSelected(selection, attribute.slug, preferredOption.value, preferredOption.unitCode);

    return (
        <div className='flex items-center justify-between gap-3 px-1 py-1'>
            <AttributeFilterTitle name={attribute.name} />
            <Switch
                className='-ml-3 shrink-0'
                color='primary'
                checked={isChecked}
                onChange={(event) => {
                    const checked = event.target.checked;
                    onSetValues(
                        attribute.slug,
                        checked
                            ? [
                                  {
                                      value: String(preferredOption.value),
                                      unitCode: preferredOption.unitCode
                                  }
                              ]
                            : [],
                        draft ? { draft: true } : undefined
                    );
                }}
            />
        </div>
    );
};
